import {combineReducers} from "redux";

import * as session from "./session";
import * as depot from "./depot";
import * as stock from "./store-management/stock";
import * as withdrawal from "../../store-management/redux";
import {routerReducer} from "@angular-redux/router";
import {MessageListFactory, UserFactory} from "./session/session.initial-state";
import {Record} from "immutable";

export interface IAppState {
  session?: session.ISession;
  depot?: depot.IDepot;
  stock?: stock.ISelectedStock;
  router?: any;
  withdrawals?: withdrawal.TempWithdrawalCache;
}

export const rootReducer = combineReducers<IAppState>({
  session: session.sessionReducer,
  depot: depot.depotReducer,
  stock: stock.stockReducer,
  router: routerReducer,
  withdrawals: withdrawal.withdrawalReducer
});

export function deimmutify(store) {
  let serial = {
    session: store.session.toJS(),
    depot: store.depot.toJS(),
    stock: store.stock.toJS(),
    router: store.router,
    withdrawals: store.withdrawals.toJS()
  };

  serial.session.isLoading = null;
  serial.session.hasError = null;
  //serial.withdrawals.activeWithdrawalCuid = null;

  return serial;
}

export function reimmutify(plain) {
  let obj = {
    session: session.SessionFactory(plain.session),
    depot: depot.DepotFactory(plain.depot),
    stock: stock.StockFactory(plain.stock),
    router: plain.router,
    withdrawals: withdrawal.TempWithdrawalCacheFactory(plain.withdrawals)
  };

  // Create immutable objects from local storage
  let sess: Record<string, any> = obj.session;
  let newSess = sess.set('messages', MessageListFactory());
  newSess = newSess.set('user', UserFactory(newSess.user));

  //TODO: Migrate withdrawals also to immutable


  obj.session = newSess;

  return obj;

}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/store.ts